/** 11 §9 FEEL constants — client config, not `sim/`. Transcribed verbatim. */
import { HITSTOP_MS } from '../../../sim/constants.js'

export const FX_HITSTOP_MS = HITSTOP_MS // 200
export const FX_HITSTOP_REDUCED_MS = 60
export const FX_HITSTOP_HUB_MS = 90
export const FX_HITSTOP_MAX_MS = 320
export const FX_HITSTOP_CATCHUP_MS = 120
export const FX_FLASH_FRAMES = 2
export const FX_FLASH_ALPHA = 0.18
export const FX_SHAKE_AMP_PX = 6
export const FX_SHAKE_MS = 180
export const FX_UNDRAW_MS = 600
export const FX_REDRAW_MS = 600
export const FX_REDRAW_FAST_MS = 300
export const FX_DISC_REDRAW_MS = 250
export const FX_DISC_UNDRAW_MS = 200
export const FX_OT_BAND_MS = 400
export const FX_TICK_ALPHA_IDLE = 0.35
export const FX_TRAIL_SEC = 0.12
export const FX_SPARK_WALL = 5
export const FX_SPARK_PILLAR = 7
export const FX_SPARK_SHIELD_LATE = 4
export const FX_SPARK_SHIELD_PERFECT = 12
export const FX_SPARK_CLASH = 10
export const FX_SPARK_LIFE_MIN_MS = 60
export const FX_SPARK_LIFE_MAX_MS = 140
export const FX_DECAL_MS = 3000
export const FX_DECAL_MAX = 24
export const FX_DASH_GHOSTS = 3
export const FX_THREAT_TIME_S = 0.35
export const FX_CHEVRON_MAX = 3
export const FX_MAX_SPARKS = 160
/** Rescind (11 §10): re-draw from the current stage at 2× speed, max 150 ms. */
export const FX_RESCIND_MAX_MS = 150

/** 09 §3 / 15 §1.7 team accents — the only saturated colour on screen. */
export const TEAM_ACCENT: Record<0 | 1, string> = { 0: '#D9572B', 1: '#2F7FB8' }
/** Neutral ink for linework (blueprint register). */
export const INK = '#E8ECEF'
export const INK_RGB = '232,236,239'
/** HUD amber for warnings (09 §1 Z2/Z8, 11 §5). */
export const AMBER = '#E0A33B'

/** 15 §2.1 bake budget (< 150 ms at every DPR): the static arena bakes at most this wide and is upscaled
 *  with image smoothing. Not an 11 §9 feel value. */
export const BAKE_MAX_W = 1920
/** Floor sample grid cap (the per-pixel inverse projection is the bake's cost); the canvas upscales it. */
export const BAKE_FLOOR_MAX_W = 640
